<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase"
        >Thêm phân công giảng dạy
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <TeachingNewForm ref="form" :defaultTeacher="defaultTeacher" :state="dialog" />
        <v-spacer style="height: 100px" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import TeachingNewForm from '@/components/basic/form/TeachingNewForm'
import { mapActions } from 'vuex'
import { get } from 'lodash'
import { Teaching } from '../../plugins/api'

export default {
  components: {
    TeachingNewForm
  },
  props: {
    state: Boolean,
    defaultTeacher: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      dialog: false,
      loading: false,
      subject: '',
      classData: '',
      grade: null,
      id: ''
    }
  },

  methods: {
    ...mapActions('teaching', ['createTeaching', 'updateTeaching']),
    async save() {
      try {
        const data = this.$refs.form.getData()
        if (!data) return
        if (this.defaultTeacher && this.defaultTeacher.id) data.teacher = this.defaultTeacher
        const t = await Teaching.fetch({
          class: data.class.id,
          subject: data.subject.id,
          teacher: data.teacher.id,
          _limit: 1
        })

        if (t && t.length && t[0].id) {
          this.$alert.error(`Giáo viên đã được phân công vào Môn ${data.subject.title} của lớp ${data.class.title}`)
          return
        }

        this.$loading.active = true
        const teachingList = await Teaching.fetch({
          class: data.class.id,
          subject: data.subject.id
        })

        const dataToApi = {
          class: data.class.id,
          grade: data.grade.id,
          subject: data.subject.id,
          subjectGroup: data.subjectGroup.id,
          teacher: data.teacher.id
        }

        if (!teachingList.length || teachingList[0].teacher) {
          // nếu chưa có teaching, hoặc nếu đã có teaching, nhưng teaching ấy đã có giáo viên
          // ==> them moi teaching

          await this.createTeaching({ ...dataToApi })
        } else {
          // không có phân công thời khóa biểu --> cập nhật PCGD

          await this.updateTeaching({ id: teachingList[0].id, ...dataToApi })
        }

        this.$alert.success('Cập nhật thành công')
        this.dialog = false
        this.$emit('done')
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    },

    onFilterChanged() {
      this.$emit('onFilterChanged', {
        id: this.id,
        grade: this.grade,
        classData: this.classData,
        subject: this.subject.id
      })
    },
    gradeChanged(grade) {
      if (get(this.grade, 'academicLevel') !== get(grade, 'academicLevel')) {
        this.classData = null
      }
      this.grade = grade
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
